import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=e080dbf4"
import script from "./Group.vue?vue&type=script&lang=ts"
export * from "./Group.vue?vue&type=script&lang=ts"
import style0 from "./Group.vue?vue&type=style&index=0&id=e080dbf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports